<template>
  <div class="ushk-content">
    <div class="ushk-main ushk-content-box">
      <div class="ushk-rili">
        <div class="ushk-rili_header">
          <div class="ushk-rili_tab">
            <ul class="ushk-rili_tab-list">
              <li v-for="(item, index) in tabs" :key="index" class="ushk-rili_tab-item" :class="{'active': item.type === active}" @click="active = item.type">{{ item.name }}</li>
            </ul>
          </div>
          <div class="ushk-rili_header-btn">
            <a href="javascript:;">
              <i class="ushk-icon ushk-icon_calendar1"></i>
              <!-- <ushk-datepicker :date="curDate"/> -->
            </a>
          </div>
        </div>
        <!-- 选择星期 -->
        <week v-if="curDate" :date="curDate" @dateChange="onDateChange"/>
        <div class="ushk-rili_body">
          <list-filter @change="filterChange"/>
          <list-group v-for="(item, key) in datas" :type="key" :datas="item" :key="key"></list-group>
        </div>
        <mobile-content :economics-datas="datas.economics" :stock-after="datas.stockAfter" :stock-pre="datas.stockPre" :stock-hk="datas.stockHk" :eventsDatas="datas.events" :holiday-datas="datas.holiday" :active="active"></mobile-content>
      </div>
    </div>
    <div class="ushk-side">
      <div class="ushk-side__wrap">
        <ad :paddingTop="false"></ad>
        <contract></contract>
        <Declatration></Declatration>
      </div>
    </div>
  </div>

</template>
<script>
  import { fetch } from '@/commons/fetch'
  import { requestUrl } from '@/commons/config'
  import { dateFormat, getQueryString } from '@/commons/utils'
  import { genClassName } from '@/commons/kind'
  import Socket from '@/plugins/socket'
  import {calendarHeaders} from '@/commons/headers'
  import { createNamespacedHelpers } from 'vuex'
  const { mapActions, mapGetters } = createNamespacedHelpers('calendar')
  export default {
    name: 'Calendar',
    computed: {
      ...mapGetters([
        'stockAffect'
      ])
    },
    data () {
      return {
        curDatas: {
          economics: [],
          stockAfter: [],
          stockPre: [],
          stockHk: [],
          events: [],
          holiday: []
        },
        datas: {
          economics: [],
          stockHk: [],
          stockPre: [],
          stockAfter: [],
          events: [],
          holiday: []
        },
        curDate: new Date(),
        socket: null,
        active: 'economics',
        tabs: [
          {
            type: 'economics',
            name: '数据'
          },
          {
            type: 'stockAfter',
            name: '美股盘后'
          },
          {
            type: 'stockPre',
            name: '美股盘前'
          },
          {
            type: 'stockHk',
            name: '港股时段'
          },
          {
            type: 'events',
            name: '事件'
          },
          {
            type: 'holiday',
            name: '假期'
          }
        ]
      }
    },
    mounted () {
      this.getCurDate()
      this.getStockAffect().then(() => {
        this.render()
        this.initSocket()
      })
      window.testUpdate = this.update
    },
    methods: {
      ...mapActions([
        'getStockAffect'
      ]),
      update (res) {
        const { type, data, action } = res
        if (action === 6) {
          const time = Math.floor(Math.random() * 30 + 1) - 1
          setTimeout(function () {
            window.location.reload()
          }, time * 1000)
          return false
        }
        if (type !== 1) {
          return false
        }
        const { data_id } = data
        const { statusClass, statusName } = genClassName(data, this.stockAffect)
        data.dataId = data_id
        data.time_show = dateFormat(data.pub_time, 'hh:mm')
        let economicsIndex = this.findData(this.datas.economics, data_id)
        let stockPreIndex = this.findData(this.datas.stockPre, data_id)
        let stockAfterIndex = this.findData(this.datas.stockAfter, data_id)
        let stockHkIndex = this.findData(this.datas.stockHk, data_id)
        let curStockPreIndex = this.findData(this.curDatas.stockPre, data_id)
        let curStockAfterIndex = this.findData(this.curDatas.stockAfter, data_id)
        let curStockHkIndex = this.findData(this.curDatas.stockHk, data_id)
        let curEconomicsIndex = this.findData(this.curDatas.economics, data_id)
        data.status_class = statusClass
        data.status_name = statusName
        economicsIndex !== -1 && this.$set(this.datas.economics, economicsIndex, data)
        stockPreIndex !== -1 && this.$set(this.datas.stockPre, stockPreIndex, data)
        stockAfterIndex !== -1 && this.$set(this.datas.stockAfter, stockAfterIndex, data)
        stockHkIndex !== -1 && this.$set(this.datas.stockHk, stockHkIndex, data)
        curStockPreIndex !== -1 && this.$set(this.curDatas.stockPre, curStockPreIndex, data)
        curStockAfterIndex !== -1 && this.$set(this.curDatas.stockAfter, curStockAfterIndex, data)
        curStockHkIndex !== -1 && this.$set(this.curDatas.stockHk, curStockHkIndex, data)
        curEconomicsIndex !== -1 && this.$set(this.curDatas.economics, curEconomicsIndex, data)
      },
      initSocket () {
        this.socket = new Socket({
          jsUrl: '//www.jin10.com/js/flash.js',
          jsName: 'flashArr',
          callback: (socket) => {
            socket.on('connect', () => {
              socket.emit('switch_channel', 3, console.log)
            })
            socket.on('flash', (msg) => {
              this.update(msg)
            })
          }
        })
      },
      filterChange ({ type, name }) {
        const datas = this.curDatas
        for (let key in datas) {
          this.datas[key] = this.filterType(datas[key], name.replace(/ /g, ''), type)
        }
      },
      filterType (datas, name, type) {
        let i = 0
        let l = datas.length
        let allData = []
        if (type === 'all') {
          allData = datas
        } else {
          for (; i < l; i++) {
          // 国家
            if (type === 'country') {
              if (datas[i].country == name) {
                allData.push(datas[i])
              }
            }
            // 未公布
            else if (type === 'actual') {
              if (!datas[i].actual || datas.status_name === '未公布') {
                allData.push(datas[i])
              }
            }
            // 重要
            else if (type === 'important') {
              if (datas[i].star > 2) {
                allData.push(datas[i])
              }
            }
          }
        }
        return allData
      },
      findData (datas, targetValue) {
        return datas.findIndex(m => m.id == targetValue)
      },
      onDateChange(date) {
        if (date === getQueryString('date')) {
          this.init()
        } else {
          location.href = `?date=${date}`
        }
      },
      getCurDate () {
        let date = getQueryString('date')
        // let curDate = date && typeof date !== 'undefined' ? date : ''
        // let y = ''
        // let m = ''
        // let d = ''
        // if (curDate) {
        //   y = curDate.slice(0, 4)
        //   m = curDate.slice(4, 6)
        //   d = curDate.slice(6, 8)
        // }

        // if (curDate) {
        //   this.curDate = new Date(y + '/' + m + '/' + d).getTime()
        // } else {
        //   this.curDate = Date.now()
        // }
        this.curDate = date ? new Date(date.replace(/-/gi, '/')) : new Date()
      },
      filterData (datas) {
        let country = ''
        let timeShow = ''
        let l = datas.length
        let i = 0
        let showCountryCount = 1
        for (; i < l; i++) {
          let oldCount = showCountryCount
          let title = datas[i].title
          if (country) {
            datas[i - showCountryCount].count = showCountryCount
          }
          if (datas[i].country !== country || (datas[i].country === country && datas[i].time_show !== timeShow)) {
            showCountryCount = 1
            country = datas[i].country
            timeShow = datas[i].time_show
            datas[i].showCountry = true
          } else {
            datas[i].showCountry = false
            showCountryCount += 1
            datas[i].count = 1
          }
          if (i === l - 1 && showCountryCount > oldCount) {
            datas[i - oldCount].count = showCountryCount
          }
          datas[i].readButton = {}
          if (title) {
            if (title.indexOf('当周EIA原油库存') !== -1) {
              datas[i].readButton.show = true
              datas[i].readButton.link = '//datacenter.jin10.com/reportType/dc_eia_crude_oil'
            } else if (title.indexOf('美国' + datas[i].datename + '季调后非农就业人口') !== -1) {
              datas[i].readButton.show = true
              datas[i].readButton.link = '//datacenter.jin10.com/reportType/dc_nonfarm_payrolls'
            }
          }
        }
        return datas
      },
      render () {
        let hasGetStockData = false
        for (let key in this.datas) {
          const isStock = key.indexOf('stock') !== -1
          if (!hasGetStockData || !isStock) {
            this.getData(isStock ? 'stock' : key).then((data) => {
              if (key === 'economics') {
                data.forEach((d, i) => {
                  const { statusClass, statusName } = genClassName(d, this.stockAffect)
                  data[i].status_class = statusClass
                  data[i].status_name = statusName
                })
              }
              if (isStock) {
                this.setStockData(data)
              } else {
                this.curDatas[key] = data
                this.datas[key] = data
              }
            })
          }
          if (isStock) {
            hasGetStockData = true
          }
        }
      },
      setStockData (datas) {
        const stockPre = []
        const stockAfter = []
        const stockHk = []
        datas.forEach(data => {
          if (data.category === 'hk') {
            stockHk.push(data)
          } else if (data.category === 'us') {
            if (data.time_show === '盘前') {
              stockPre.push(data)
            } else if (data.time_show === '盘后') {
              stockAfter.push(data)
            } else {
              // 盘前
              if (this.compareTime(data.time_show, '17:00', '22:30')) {
                stockPre.push(data)
              } else if (this.compareTime(data.time_show, '05:00', '09:00')) {
                stockAfter.push(data)
              }
            }
          }
        })
        this.curDatas.stockPre = stockPre
        this.curDatas.stockAfter = stockAfter
        this.curDatas.stockHk = stockHk
        this.datas.stockPre = stockPre
        this.datas.stockAfter = stockAfter
        this.datas.stockHk = stockHk
      },
      compareTime (btime, stime, etime) {
        if (!btime) {
          return false
        }
        // 转换时间格式，并转换为时间戳
        function tranDate (time) {
          return new Date(time.replace(/-/g, '/')).getTime()
        }

        const thisDate = new Date()
        const y = thisDate.getFullYear() + '-' + (thisDate.getMonth() + 1) + '-' + thisDate.getDate() + ' '
        // 开始时间
        const startTime = tranDate(y + stime)
      // 结束时间
        const endTime = tranDate(y + etime)
        const curTime = tranDate(y + btime)
        // 如果当前时间处于时间段内，返回true，否则返回false
        if (curTime < startTime || curTime > endTime) {
          return false
        }
        return true
      },
      getData (type) {
        return new Promise((resolve, reject) => {
          this.isLoading = true
          let date = dateFormat(new Date(this.curDate), 'yyyyMMdd')
          fetch({
            url: requestUrl.rili[type],
            params: {
              date
            },
            type: 'get',
            useJson: true,
            headers: calendarHeaders,
            // jsonpCallback: 'callback',
            callback: (res) => {
              this.isLoading = false
            },
            success: (res) => {
              resolve(res.data)
            },
            error: () => {
              this.isLoading = false
            }
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// home.vue?3ebbf8c6